import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const DogServiceApi = createApi({
  reducerPath: 'dogService',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getServices: builder.query({
      query: () => ({
        url: `/api/service/getServices`,
        method: 'GET',
      }),
    }),
    getServiceByID: builder.query({
      query: id => ({
        url: `/api/service/getServiceById/${id}`,
        method: 'GET',
      }),
    }),
    updateService: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `/api/service/updatedService/${id}`,
          method: 'PUT',
          body: body,
        };
      },
    }),
    createService: builder.mutation({
      query: body => ({
        url: `/api/service/createService`,
        method: 'POST',
        body: body,
      }),
    }),
    deleteService: builder.mutation({
      query: ({ id }) => {
        return {
          url: `api/service/deleteService/${id}`,
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useCreateServiceMutation,
  useUpdateServiceMutation,
  useDeleteServiceMutation,
  useGetServiceByIDQuery,
  useLazyGetServiceByIDQuery,
  useGetServicesQuery,
  useLazyGetServicesQuery,
} = DogServiceApi;
